"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ellipseshorizontal = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-ellipseshorizontal` : '') + (description ? ` desc-ellipseshorizontal` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-ellipseshorizontal"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-ellipseshorizontal"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.44 10a2.47 2.47 0 0 1 2.43 2.5c0 1.38-1.09 2.5-2.43 2.5A2.47 2.47 0 0 1 3 12.5C3 11.12 4.1 10 5.44 10ZM12 10a2.47 2.47 0 0 1 2.44 2.5c0 1.38-1.1 2.5-2.44 2.5a2.47 2.47 0 0 1-2.44-2.5c0-1.38 1.1-2.5 2.44-2.5Zm6.56 0A2.47 2.47 0 0 1 21 12.5c0 1.38-1.1 2.5-2.44 2.5a2.47 2.47 0 0 1-2.43-2.5c0-1.38 1.09-2.5 2.43-2.5Z",
    fill: "#232323"
  }));
};
var _default = exports.default = ellipseshorizontal;